export default {
    FLUID: 'fluid',
    FIT_TO_WIDTH: 'fit-to-width',
    FIT_TO_CONTAINER: 'fit-to-container',
    FIT_TO_NATIVE: 'fit-to-native',
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/constants/zoom-level-constants.js